import { centerable as r } from "../decorators/centerable.js";
import { stylable as i } from "../decorators/stylable.js";
import { generateHeadingId as t } from "../../helpers/id-generator.js";
const d = i(
  r({
    content: "inline*",
    attrs: {
      type: { default: "heading" },
      idAttribute: { default: "" }
    },
    defining: !0,
    group: "block",
    parseDOM: [
      {
        tag: "h1",
        getAttrs() {
          return {
            idAttribute: t()
          };
        }
      },
      {
        tag: 'p[role=heading][aria-level="1"]',
        priority: 60,
        getAttrs() {
          return {
            idAttribute: t()
          };
        }
      }
    ],
    toDOM(e) {
      return ["h1", { id: e.attrs.idAttribute }, 0];
    }
  })
), g = i(
  r({
    content: "inline*",
    attrs: {
      type: { default: "subheading" },
      idAttribute: { default: "" }
    },
    defining: !0,
    group: "block",
    parseDOM: [
      {
        tag: "h2",
        getAttrs() {
          return {
            idAttribute: t()
          };
        }
      },
      {
        tag: 'p[role=heading][aria-level="2"]',
        priority: 60,
        getAttrs() {
          return {
            idAttribute: t()
          };
        }
      },
      {
        tag: "h3",
        getAttrs() {
          return {
            idAttribute: t()
          };
        }
      },
      {
        tag: 'p[role=heading][aria-level="3"]',
        priority: 60,
        getAttrs() {
          return {
            idAttribute: t()
          };
        }
      },
      {
        tag: "h4",
        getAttrs() {
          return {
            idAttribute: t()
          };
        }
      },
      {
        tag: 'p[role=heading][aria-level="4"]',
        priority: 60,
        getAttrs() {
          return {
            idAttribute: t()
          };
        }
      }
    ],
    toDOM(e) {
      return ["h2", { id: e.attrs.idAttribute }, 0];
    }
  })
), o = i(
  r({
    content: "inline*",
    attrs: {
      type: { default: "subheading3" },
      idAttribute: { default: "" }
    },
    defining: !0,
    group: "block",
    parseDOM: [],
    toDOM(e) {
      return ["h3", { id: e.attrs.idAttribute }, 0];
    }
  })
), l = i(
  r({
    content: "inline*",
    attrs: {
      type: { default: "subheading4" },
      idAttribute: { default: "" }
    },
    defining: !0,
    group: "block",
    parseDOM: [],
    toDOM(e) {
      return ["h4", { id: e.attrs.idAttribute }, 0];
    }
  })
);
export {
  d as headingSpec,
  o as subheading3Spec,
  l as subheading4Spec,
  g as subheadingSpec
};
